import { format } from 'date-fns';
import { enUS, th } from 'date-fns/locale'
import useSite from 'hooks/use-site';
import moment from 'moment';
import 'moment/locale/th'
const locales = {enUS, th}

/**
 * formatDate
 */

export function formatDateOld(date, pattern = 'PPP') {
  const { locale } = useSite()
  const localePrefix = locale === 'TH' ? 'th' : 'enUS' 
  return format(new Date(date), pattern, {
    locale: locales[localePrefix]
  });
}

export function formatDate(date, locale = 'en', type = 'date') {
  const datetime = moment(date)
  const day = datetime.format('DD')
  const month = datetime.locale(locale).format('MMMM')
  const year = locale === 'th' ? Number(datetime.format('YYYY')) + 543 : datetime.format('YYYY')
  const time = datetime.format('HH:mm:ss')
  return type === 'date' ? `${day} ${month} ${year}` : `${day} ${month} ${year} ${time}`
}

/**
 * sortObjectsByDate
 */

export function sortObjectsByDate(array, { key = 'date' } = {}) {
  return array.sort((a, b) => new Date(b[key]) - new Date(a[key]));
}
